import { ThemeSettingsBaseSectionHandler } from '../settings.section';
import { ThemeResponse } from '@key-telematics/fleet-api-client';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { AdminEditorService } from '../../../admin.service';
import { ThemeEngine } from 'app/shared/components/theme';

export class ContentSettingsSectionHandler extends ThemeSettingsBaseSectionHandler {

    constructor(admin: AdminEditorService, ownerId: string, themeEngine: ThemeEngine) {
        super(admin, ownerId, themeEngine, 'content');
    }

    async getFields(_entity: ThemeResponse): Promise<FormBuilderField[]> {
        return [
            this.fontColorComboField('font.color', ['main', 'header']),
            this.backgroundColorField('background.color', ['main']),
            this.borderColorField('border.color', ['main']),
            this.sizeNumberField('separator.width', 'px'),
            this.borderColorField('separator.color', ['main', 'content']),
            this.borderColorField('separator.handle.color', ['main', 'content']),
            this.dropShadowField('shadow'),
        ];
    }

}
